import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserAuthentified } from '@app/authentification/user-authentified.interface';
import { EaDisplay } from '@app/components/pr-display';
import { UserService } from '@app/providers/user/user.service';
import { take, tap } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

@Component({
    selector: 'form-footer',
    templateUrl: './form-footer.component.html',
    styleUrls: ['./form-footer.component.scss'],
    standalone: false
})
export class FormFooterComponent implements OnInit {
  @Input() nextLabel = 'Question suivante';
  @Input() disabledNext = false;
  @Input() disabledPrev = false;
  @Input() disabledSkip = false;
  @Input() prevLabel = 'Question précédente';
  @Input() sendCompletion = 'Completion du funnel par le client';
  @Input() leadEmailSend: boolean = false;
  @Input() hideSendCompletion: boolean = true;
  @Input() displaySendCompletion: EaDisplay = EaDisplay.neutral;
  @Input() displayNext: EaDisplay = EaDisplay.neutral;
  @Output() next = new EventEmitter<any>();
  @Output() prev = new EventEmitter<any>();
  @Output() sendCompletionSubscription = new EventEmitter<any>();
  step;
  disabledSkipBtn = false;
  sessionConsultant = false;
  user = undefined;

  QUESTION_CATEGORIES_WITHOUT_SKIP = ['Composition du crédit'];
  QUESTION_NAMES_WITHOUT_SKIP = ['isinTable', 'ownerTaxResidence'];

  @Input() form: FormGroup = null;
  constructor(
    public subscriptionFacade: SubscriptionFacadeService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.step = this.subscriptionFacade.getStep();
    const pledge = this.subscriptionFacade.getPledge();
    this.userService
      .getUser()
      .pipe(
        take(1),
        tap((user: UserAuthentified) => {
          this.user = user;
          if (pledge) this.sessionConsultant = !!user.sessionConsultant;
        }),
      )
      .subscribe();
    const question = this.subscriptionFacade.getQuestion();

    if (
      this.QUESTION_CATEGORIES_WITHOUT_SKIP.includes(question?.category) ||
      this.QUESTION_NAMES_WITHOUT_SKIP.includes(question?.name)
    ) {
      this.disabledSkipBtn = true;
    } else if (question?.callbackValidation) {
      this.disabledSkipBtn = !question.callbackValidation(
        pledge,
        this.subscriptionFacade.getUser(),
      );
    } else {
      this.disabledSkipBtn = false;
    }
  }

  onNext() {
    this.next.emit();
  }

  onPrev() {
    this.prev.emit();
  }

  onSendCompletionSubscription() {
    this.sendCompletionSubscription.emit();
    this.next.emit();
  }
  notifyClick() {
    if (this.form) {
      this.next.emit();
      return;
    }
    this.subscriptionFacade.notifyClick();
  }
}
